import HttpClientToken from '../../services/HttpClientToken';

import { defaultTipoIrregular, TipoIrregularProps } from '../../interfaces/catalogos/TipoIrregularInterface';

export const TipoIrregulares = () => {

    return new Promise<TipoIrregularProps[]>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoIrregular/', token)
            .then( ({ data } : { data : TipoIrregularProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerTipoIrregular = () => {

    return new Promise<TipoIrregularProps[]>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoIrregular/ObtenerTipoIrregulares', token)
            .then( ({ data } : { data : TipoIrregularProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarTipoIrregular = ( params: TipoIrregularProps ) => {

    return new Promise<TipoIrregularProps>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoIrregular/Actualizar', params, token)
            .then( ({ data } : { data : TipoIrregularProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoIrregular } );
            });

        }

    });

}

export const AgregarTipoIrregular = ( params: TipoIrregularProps ) => {

    return new Promise<TipoIrregularProps>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoIrregular/Agregar', params, token)
            .then( ({ data } : { data : TipoIrregularProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoIrregular } );
            });

        }

    });

}
